import React from 'react';
import dayjs from 'dayjs';
import { Tooltip } from 'antd';
// Step names from API_REFERENCE "Financial ledger" (history[].step).
const STEP_LABELS = {
  created: 'Created', activated: 'Activated', shared: 'Shared', cancel_requested: 'Cancel requested', cancelled: 'Cancelled',
  expired: 'Expired', paid: 'Paid', reported: 'Reported', verified: 'Verified', rejected: 'Rejected', withdrawn: 'Withdrawn',
  reversed: 'Reversed', terms_changed: 'Terms changed', superseded: 'Replaced', settled: 'Settled', requested: 'Requested',
  approved: 'Approved', registered: 'Registered', collected: 'Collected', cleared: 'Cleared', bounced: 'Bounced',
  returned: 'Returned', accepted: 'Accepted', recorded: 'Recorded',
};
const SHARE_CHANNELS = { auto: 'on WhatsApp', record_only: 'another way' };
export const stepLabel = item => {
  const base = STEP_LABELS[item.step] || String(item.step || '').replace(/_/g, ' ');
  return item.step === 'shared' && SHARE_CHANNELS[item.detail?.channel] ? `${base} ${SHARE_CHANNELS[item.detail.channel]}` : base;
};
// A row's lifecycle, oldest first. One date prefix when every step is on the same day.
export default function LedgerSteps({ history }) {
  const steps = (history || []).filter(item => item?.at);
  if (!steps.length) return null;
  const days = new Set(steps.map(item => dayjs(item.at).format('YYYY-MM-DD')));
  const sameDay = days.size === 1;
  return <span className="pv2-ledger-steps">
    {sameDay && <span className="pv2-ledger-day">{dayjs(steps[0].at).format('DD-MMM-YYYY')} ·</span>}
    {steps.map((item, index) => <React.Fragment key={`${item.step}-${item.at}-${index}`}>
      {index > 0 && <span className="pv2-ledger-arrow" aria-hidden>→</span>}
      <Tooltip title={item.actorName ? `by ${item.actorName}` : null}>
        <span className="pv2-ledger-step">{stepLabel(item)} {dayjs(item.at).format(sameDay ? 'hh:mm A' : 'DD-MMM hh:mm A')}</span>
      </Tooltip>
    </React.Fragment>)}
  </span>;
}
